var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignupStep5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Steeper/05 Plan Selection") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 19.9995 0 19.9995 19.819 0 19.819"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Steeper/05-Plan-Selection",
    stroke: "none",
    strokeWidth: 1,
    fill: "current",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(-0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.8581,9.3082 L8.4381,10.2962 C8.2451,10.4312 7.9901,10.2452 8.0581,10.0202 L8.5591,8.3642 C8.5891,8.2652 8.5541,8.1572 8.4711,8.0942 L7.0931,7.0492 C6.9051,6.9062 7.0021,6.6072 7.2381,6.6022 L8.9671,6.5672 C9.0711,6.5652 9.1631,6.4982 9.1971,6.4002 L9.7651,4.7662 C9.8431,4.5432 10.1581,4.5432 10.2351,4.7662 L10.8031,6.4002 C10.8371,6.4982 10.9291,6.5652 11.0331,6.5672 L12.7621,6.6022 C12.9981,6.6072 13.0951,6.9062 12.9071,7.0492 L11.5291,8.0942 C11.4461,8.1572 11.4111,8.2652 11.4411,8.3642 L11.9421,10.0202 C12.0101,10.2452 11.7561,10.4312 11.5621,10.2962 L10.1421,9.3082 C10.0571,9.2492 9.9431,9.2492 9.8581,9.3082",
    id: "Fill-1",
    fill: "current"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7795,17.539 L10.5455,16.703 C10.2455,16.591 9.9165,16.589 9.6165,16.697 L7.2215,17.559 L7.2215,14.941 L12.7795,14.941 L12.7795,17.539 Z M16.8725,0 L3.1325,0 C1.4055,0 -0.0005,1.405 -0.0005,3.132 L-0.0005,4.886 C-0.0005,5.44 0.4485,5.889 1.0035,5.889 C1.5575,5.889 2.0065,5.44 2.0065,4.886 L2.0065,3.132 C2.0065,2.511 2.5115,2.006 3.1325,2.006 L16.8725,2.006 C17.4905,2.006 17.9935,2.509 17.9935,3.127 L17.9935,11.849 C17.9935,12.448 17.5065,12.935 16.9085,12.935 L3.1075,12.935 C2.4995,12.935 2.0065,12.441 2.0065,11.834 L2.0065,8.9 C2.0065,8.346 1.5575,7.897 1.0035,7.897 C0.4485,7.897 -0.0005,8.346 -0.0005,8.9 L-0.0005,11.834 C-0.0005,13.547 1.3935,14.941 3.1075,14.941 L5.2155,14.941 L5.2155,18.414 C5.2155,18.871 5.4395,19.302 5.8145,19.565 C6.0535,19.732 6.3365,19.819 6.6205,19.819 C6.7805,19.819 6.9425,19.792 7.0965,19.735 L10.0675,18.667 L12.8855,19.721 C13.3175,19.884 13.8015,19.824 14.1795,19.561 C14.5595,19.298 14.7855,18.867 14.7855,18.406 L14.7855,14.941 L16.9085,14.941 C18.6125,14.941 19.9995,13.554 19.9995,11.849 L19.9995,3.127 C19.9995,1.402 18.5975,0 16.8725,0 L16.8725,0 Z",
    id: "Fill-3",
    fill: "current"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupStep5);
export default __webpack_public_path__ + "static/media/signup-step-5.f1463f710fa9ab5f1b4ac8d3036d10a6.svg";
export { ForwardRef as ReactComponent };